import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { CheckCircle } from "~/icons";

export const NewsletterFormConfirmation: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex
      align="center"
      bg="bg-main"
      direction="column"
      py={4}
      rounded="lg"
      w="100%"
    >
      <CheckCircle color="fg-accent" h="3.25rem" mb={4} w="3.25rem" />
      <Text size="xl">{t("newsletterForm.confirmation")}</Text>
    </Flex>
  );
};
